export default {"src":"/_next/static/image/src/images/Footer/twitter.6d5b89bc47c562e35cb549b293d36063.svg","height":18,"width":20};